import { auth, users, vehicle, catalog, servicing, slimpay, zuora, agreements, assets } from '.';

//Rollbar is a global variable, lint complains
//https://github.com/facebook/create-react-app/blob/master/packages/react-scripts/template/README.md#using-global-variables
const Rollbar = window.Rollbar;

const api = ({ action }, ...params) => {
  const apis = {
    'get users': users.getAll,
    'get user': users.get,
    'download contract': users.downloadContract,
    heartbeat: users.heartbeat,
    'new registration': users.post,
    'get asset': users.getAssetDetailed,
    'update asset': users.updateAsset,
    'update user': users.update,
    'activate zuora': users.activateZuora,
    'create agreement': users.createAgreement,
    'create agreement for agricar': users.createAgreementForAgricar,
    'send validation': users.sendValidation,
    'send contracts': users.sendContracts,
    'delete user': users.delete,
    login: auth.login,
    'refresh token': auth.refreshToken,
    profile: auth.profile,
    'get makers': vehicle.makers,
    'get models by maker': vehicle.models,
    'get types by model': vehicle.types,
    'get motorbike makers': vehicle.motorbikeMakers,
    'get motorbike models by maker': vehicle.motorbikeModels,
    'get motorbike types by model': vehicle.motorbikeTypes,
    'get infocar': vehicle.infocar,
    'get motorbike infocar': vehicle.infocarMotorbike,
    'configure munic': vehicle.confMunicShutdown,
    'register vehicle': vehicle.registerVehicle,
    'get catalog': catalog.get,
    'get serviceTypes': servicing.getServiceTypes,
    'create slimpay mandate': slimpay.createMandate,
    'add credit card payment method': zuora.creditCard,
    'get installations check': agreements.installationsCheck,
    'get subscriptions': agreements.subscriptions,
    'delete attachment': agreements.delete,
    'download attachment': agreements.download,
    'subscribe offer': vehicle.municSubscribeOffer,
    'get active insurance policy': catalog.getActiveInsurancePolicy,
    'get asset service level': assets.getAsset,
    'getZuoraToken': zuora.getZuoraToken,
    'setPaymentMethodDefault': zuora.setPaymentMethodDefault,
  };

  try {
    return apis[action](...params);
  } catch (error) {
    console.error(`action: ${action} - error: ${error}`);
    Rollbar.error(error, function(err, data) {
	    if (err) {
		    console.log("Error while reporting error to Rollbar: ", err);
	    } else {
		    console.log("Error successfully reported to Rollbar. UUID:", data.result.uuid);
	    }
    });
    return Promise.reject(Object.assign({}, error, { severity: 'high' }));
  }
};

export default api;



// WEBPACK FOOTER //
// ./src/services/api.js